module.exports = __webpack_public_path__ + "img/space_dust_orange_front.0d7eda92.jpg";